import { render } from "./InstallmentsView.vue?vue&type=template&id=88b4742a&scoped=true&ts=true"
import script from "./InstallmentsView.vue?vue&type=script&lang=ts"
export * from "./InstallmentsView.vue?vue&type=script&lang=ts"

import "./InstallmentsView.vue?vue&type=style&index=0&id=88b4742a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b4742a"]])

export default __exports__